var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnimatedGif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 22V2H22V22H2ZM4.22222 19.7778H19.7778V4.22222H4.22222V19.7778ZM10.8889 15.3333H12.5556V8.66667H10.8889V15.3333ZM5.33333 15.3333H9.77778V12H8.11111V13.6667H7V10.3333H9.77778V8.66667H5.33333V15.3333ZM14.2222 15.3333H15.8889V13.1111H18.1111V11.4444H15.8889V10.3333H19.2222V8.66667H14.2222V15.3333Z",
    fill: "#1C1356"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedGif);
export default __webpack_public_path__ + "static/media/animated-gif.bf4e62a2.svg";
export { ForwardRef as ReactComponent };